import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import UnsereLeistungen from "./sections/UnsereLeistungen";
import WarumS2Automation from "./sections/WarumS2Automation";
import WarumS2AutomationServices from "../Services/sections/WarumS2Automation";
import ZusammenarbeitMitElektrofachbetrieben from "./sections/ZusammenarbeitMitElektrofachbetrieben";
import ReadyForYourProject from "./sections/ReadyForYourProject";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <UnsereLeistungen />
      <WarumS2Automation />
      <ZusammenarbeitMitElektrofachbetrieben />
      <WarumS2AutomationServices />
      <ReadyForYourProject />
      <Footer />
    </div>;
}